const LoginAttempts = () => import("Core/configuration/login_attempts/views/LoginAttempts");

// ROUTE OPTION - `pathToRegexpOptions: { strict: true }` makes trailing slashes fail to match path
export default {
    children: [
        {
            path: "configuration/login_attempts",
            name: "settings_login_attempts",
            component: LoginAttempts,
            meta: {
                requiresAuth: true,
                title: "lang.login_attempts",
                restrict_by_login_type: ["employee", "customer_support", "administrator", "developer"],
                restrict_by_permission: ["configuration.read"],
            },
        },
    ],
};
